import styles from "./TeamSettings.module.css";
import React from "react";

type TeamNameInputProps = {
  name: string;
  setName: (name: string) => void;
};

export const TeamNameInput = ({ name, setName }: TeamNameInputProps) => {
  return (
    <div
      className="select-component__duration-section"
      style={{ marginTop: "0", marginBottom: "0" }}
    >
      <div className="duration-field-row">
        <p>Team name</p>
        <input
          id="add-team-name"
          className={styles["team-settings-invite-form-input"]}
          type="text"
          onChange={(e) => {
            setName(e.target.value);
          }}
          value={name}
          placeholder="Team name"
          autoComplete="off"
        />
      </div>
    </div>
  );
};
